import Button from "@app/sharedComponents/Button/Button"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import Right from '../../../../assets/Icons/Right'

const ConfirmManualPay =({interestStatus,continuePayment})=>{
    return(
        <ThemedView p="lg" backgroundColor="bg-fill-primary">
            <ThemedText variant="h5s" color="text-primary" mb="lg" mr="2xl">
            Are you sure you want to pay interest manually?
            </ThemedText>
            {
                interestStatus === "AWAITING_MANDATE_STATUS" ? (
                    <>
                    <ThemedView  flexDirection="row"  > 
                    <Right size={16} color={themeColorSet["text-primary"]} style={{marginTop:4}}/>
                    <ThemedView ml="md" flex={1}>
                        <ThemedText variant="b3s" color="text-primary">Who should make manual payment?</ThemedText>
                        <ThemedText variant="b4r" color="text-secondary">
                        If your bank account is inactive or mandate has not been registered
                    </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView width={'100%'} height={1} backgroundColor="border-secondary" my="lg" />
                <ThemedView  flexDirection="row" mb="2xl" > 
                    <Right size={16} color={themeColorSet["text-primary"]} style={{marginTop:4}} />
                    <ThemedView ml="md" flex={1}>
                        <ThemedText variant="b3s" color="text-primary">We will still attempt auto-debit</ThemedText>
                        <ThemedText variant="b4r" color="text-secondary">
                        Any additional payments will be adjusted to your balance
                    </ThemedText>
                    </ThemedView>
                </ThemedView>
                </>
                ):(
                    <>
                     <ThemedView  flexDirection="row"  > 
                        <Right size={16} color={themeColorSet["text-primary"]} style={{marginTop:4}}/>
                        <ThemedView ml="md" flex={1}>
                            <ThemedText variant="b3s" color="text-primary">Who opt for manual payment?</ThemedText>
                            <ThemedText variant="b4r" color="text-secondary">
                            Manual interest payment is for users with bank account inactive or mandate not registered
                        </ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView width={'100%'} height={1} backgroundColor="border-secondary" my="lg" />
                    <ThemedView  flexDirection="row" mb="2xl" > 
                        <Right size={16} color={themeColorSet["text-primary"]} style={{marginTop:4}} />
                        <ThemedView ml="md" flex={1}>
                            <ThemedText variant="b3s" color="text-primary">In case of additional payment</ThemedText>
                            <ThemedText variant="b4r" color="text-secondary">
                            Auto-debit will still be attempted on your registered bank account. Any additional payments will be adjusted to your balance.
                        </ThemedText>
                        </ThemedView>
                    </ThemedView>
                    </>
                )
            }
           
            <Button label="Continue" handlePress={continuePayment}/>
        </ThemedView>
    )
}

export default ConfirmManualPay